import React from "react";
import "../styles/components/loader.scss";

export default function Loader() {
    return (
        <div className="loader_container">
            <div className="progress">
                <div className="indeterminate"></div>
            </div>
            {/* <div className="central-loader_container">
                <div className="central-loader"/>
            </div> */}
        </div>
    );
}